import React from 'react';
export function Footer() {
  return <footer className="w-full px-5 py-10" data-id="element-114" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-115" data-mp="3geze367ujv27">
        <p className="font-display text-base font-semibold text-ink" data-id="element-116" data-mp="3ggk7gsifd7yh">
          Wizualna Chemia™ | Edycja 2026
        </p>
        <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-117" data-mp="32m1cv38q38qq">
          Produkt cyfrowy • Jednorazowa płatność • Bez abonamentu
        </p>
        <p className="mt-3 text-xs leading-relaxed text-ink/45" data-id="element-118" data-mp="3ues7xaeo6ree">
          Materiały przeznaczone do własnej pracy nauczyciela z uczniami.
        </p>
      </div>
    </footer>;
}